<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [verifyRequiredValidator]="verifyRequiredValidator" [(isBusyMessage)]="isBusyMessage" [titleText]="tooltipText"
    [modalHelpIndex]="modalHelpIndex" [ngStyle]="{'width': operationType === 'select' ? '100%' : '440px'}">
    <div class="modal-row">
        <div class="modal-row-column-auto" *ngIf="operationType !== 'select'">
            <label for="filter">Tag(s):</label>
        </div>
        <div class="modal-row-column-max">
            <res-filter data-automation-id="tags-filter-input" [maxChars]=32 [placeholder]='"Filter..."'
                [callback]="filterData.bind(this)"></res-filter>
        </div>
    </div>
    <div class="modal-row tags-row">
        <div class="modal-row-column-auto" *ngIf="operationType !== 'select'"></div>
        <div class="modal-row-column-max all-tags">
            <div class="new-tag" *ngIf="newTagVisible && hasCreateTagPermissions"
                data-automation-id="tags-new-tag-button" (click)="newTag()">
                <i class="fa fa-plus new-tag-icon"></i>
                <span class="new-tag-text">New Tag...</span>
            </div>
            <div class="tags">
                <div class="tag-list">
                    <res-custom-checkbox *ngFor='let tag of filteredTags; index as i' [automationId]="'tag-input-' + i"
                        [(ngModel)]="tag.selected" (ngModelChange)="tagSelected(tag)" [content]="tag.name"
                        iconClass="fa-tag" [iconHexColor]="tag.displayValue" [labelPaddingLeft]="10">
                    </res-custom-checkbox>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-row" *ngIf="scopeVisible">
        <div class="modal-row-column-auto scopeLabel">Scope:</div>
        <div class="modal-row-column-max scope">
            <button data-automation-id="tags-scope-document-radio-button" type="button"
                [ngClass]="scope === TagScope.DOCUMENT_ONLY ? 'btn-group-active' : 'btn-group-default'"
                (click)="setScope(TagScope.DOCUMENT_ONLY)" [disabled]="documentScopeDisabled">
                <div>Document</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
            <button data-automation-id="tags-scope-family-radio-button" type="button"
                [ngClass]="scope === TagScope.MESSAGE_ATTACHMENT_GROUP ? 'btn-group-active' : 'btn-group-default'"
                (click)="setScope(TagScope.MESSAGE_ATTACHMENT_GROUP)" [disabled]="familyScopeDisabled">
                <div>Family</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
            <button data-automation-id="tags-scope-thread-radio-button" type="button"
                [ngClass]="scope === TagScope.EMAIL_THREAD ? 'btn-group-active' : 'btn-group-default'"
                (click)="setScope(TagScope.EMAIL_THREAD)" [disabled]="threadScopeDisabled">
                <div>Thread</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
        </div>
    </div>
    <div class="modal-row" *ngIf="descriptionVisible">
        <div class="modal-row-column-auto">
            <label for="description">Comment:</label>
        </div>
        <div class="modal-row-column-max description">
            <textarea id="description" [(ngModel)]="description" data-automation-id="tags-comment-input" maxlength="255"
                title="255 characters max." name="description"></textarea>
        </div>
    </div>
</res-base-modal>